/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */

import {ImageContainerDimensionsRestDto} from ".";
import {ImagePositioningRestDto} from ".";
import {ImageRoundingRestDto} from ".";
import {MultilingualMax100FieldRestDto} from ".";
import {MultilingualMax2000FieldRestDto} from ".";
import {MultilingualMax50FieldRestDto} from ".";
import {OverlayRestDto} from ".";
import {BorderTypeEnum} from "@/api/enums/border-type-enum";
import {BorderWidthEnum} from "@/api/enums/border-width-enum";
import {HorizontalImageShiftEnum} from "@/api/enums/horizontal-image-shift-enum";
import {ImageTargetEnum} from "@/api/enums/image-target-enum";
import {LightboxLayoutEnum} from "@/api/enums/lightbox-layout-enum";
import {VerticalImageShiftEnum} from "@/api/enums/vertical-image-shift-enum";

/**
 * @export
 * @interface ImageRestDto
 */
export interface ImageRestDto {
    /**
     * 
     * @type {MultilingualMax100FieldRestDto|null}
     * @memberof ImageRestDto
     */
    title?: MultilingualMax100FieldRestDto|null;

    /**
     * 
     * @type {MultilingualMax50FieldRestDto}
     * @memberof ImageRestDto
     */
    image_key: MultilingualMax50FieldRestDto;

    /**
     * The html target for this image.
     * @type {ImageTargetEnum|null}
     * @memberof ImageRestDto
     */
    image_target?: ImageTargetEnum|null;

    /**
     * 
     * @type {MultilingualMax2000FieldRestDto|null}
     * @memberof ImageRestDto
     */
    image_url?: MultilingualMax2000FieldRestDto|null;

    /**
     * 
     * @type {MultilingualMax50FieldRestDto|null}
     * @memberof ImageRestDto
     */
    image_page_id?: MultilingualMax50FieldRestDto|null;

    /**
     * The specifies the type of lightbox that is supported for this image.
     * @type {LightboxLayoutEnum}
     * @memberof ImageRestDto
     */
    lightbox_layout_code: LightboxLayoutEnum;

    /**
     * The specifies the type of border for this image.
     * @type {BorderTypeEnum}
     * @memberof ImageRestDto
     */
    border_type_code: BorderTypeEnum;

    /**
     * The specifies the width of the image border if border_type_code &lt;&gt; NONE.
     * @type {BorderWidthEnum|null}
     * @memberof ImageRestDto
     */
    border_width_code?: BorderWidthEnum|null;

    /**
     * Defines the container dimensions (width percentage, aspect ratio, max height) for this image.
     * @type {ImageContainerDimensionsRestDto|null}
     * @memberof ImageRestDto
     */
    container_dimensions?: ImageContainerDimensionsRestDto|null;

    /**
     * Defines the positioning of this image within its container.
     * @type {ImagePositioningRestDto|null}
     * @memberof ImageRestDto
     */
    positioning?: ImagePositioningRestDto|null;

    /**
     * Determines the horizontal shift of the image, rendered via CSS transform: translate(). Null means no horizontal shift is applied.
     * @type {HorizontalImageShiftEnum|null}
     * @memberof ImageRestDto
     */
    horizontal_image_shift_code?: HorizontalImageShiftEnum|null;

    /**
     * Determines the vertical shift of the image, rendered via CSS transform: translate(). Null means no vertical shift is applied.
     * @type {VerticalImageShiftEnum|null}
     * @memberof ImageRestDto
     */
    vertical_image_shift_code?: VerticalImageShiftEnum|null;

    /**
     * Optional per-corner border-radius configuration for this image. Null means no rounding is applied (all corners sharp).
     * @type {ImageRoundingRestDto|null}
     * @memberof ImageRestDto
     */
    rounding?: ImageRoundingRestDto|null;

    /**
     * Decorative overlay layers stacked on top of this image, ordered by sort_weight ascending (stacking order, bottom to top). Empty or absent when no overlay layers are configured.
     * @type {OverlayRestDto[]|null}
     * @memberof ImageRestDto
     */
    overlays?: OverlayRestDto[]|null;

}

/**
 * @export
 * @function cloneImageRestDtoMetaData
 */
export function cloneImageRestDtoMetaData(dto: ImageRestDto, source: ImageRestDto): void {
    dto.image_target = source.image_target;
    dto.lightbox_layout_code = source.lightbox_layout_code;
    dto.border_type_code = source.border_type_code;
    dto.border_width_code = source.border_width_code;
    dto.container_dimensions = source.container_dimensions;
    dto.positioning = source.positioning;
    dto.horizontal_image_shift_code = source.horizontal_image_shift_code;
    dto.vertical_image_shift_code = source.vertical_image_shift_code;
    dto.rounding = source.rounding;
    dto.overlays = source.overlays;
}
